export default __webpack_public_path__ + "static/media/img14.7741b391.PNG";